import { render, staticRenderFns } from "./AttachmentsField.vue?vue&type=template&id=03e695f5"
import script from "./AttachmentsField.vue?vue&type=script&lang=ts"
export * from "./AttachmentsField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports